import { formatDistanceToNow } from "date-fns"

/**
 * Display formatting shared across the admin pages. Every helper is
 * null-tolerant and falls back to the em-dash sentinel, so callers can feed
 * nullable serializer fields straight in.
 */

const utcStamp = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
  timeZone: "UTC",
})

/**
 * Absolute stamp, second precision, rendered in UTC — searchable in a Render
 * log stream, whose lines are UTC. Browser-local rendering would miss those
 * lines by the viewer's whole offset (ten hours from Sydney).
 */
export const formatAt = (iso: string | null) => {
  if (!iso) return "—"

  const parts = Object.fromEntries(
    utcStamp
      .formatToParts(new Date(iso))
      .map((part) => [part.type, part.value]),
  )
  return `${parts.day} ${parts.month} ${parts.year} at ${parts.hour}:${parts.minute}:${parts.second} UTC`
}

export const formatRelative = (iso: string | null) =>
  iso ? formatDistanceToNow(new Date(iso), { addSuffix: true }) : "—"

/** Rounds hard on purpose: "43 min" reads, "2,580s" does not. */
export const humanDuration = (seconds: number | null) => {
  if (seconds === null) return "—"
  if (seconds < 90) return `${seconds}s`
  if (seconds < 5400) return `${Math.round(seconds / 60)} min`
  return `${Math.round(seconds / 3600)} h`
}

export const display = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "—"
  return String(value)
}
